import { OptionButton } from './OptionButton'
import type { SingleSelectPage } from '@/content/quiz/types'
import { SocialProofBlock } from './SocialProofBlock'

interface SingleSelectQuestionProps {
  page: SingleSelectPage
  value?: string
  onSelect: (value: string) => void
}

export function SingleSelectQuestion({ page, value, onSelect }: SingleSelectQuestionProps) {
  return (
    <div className="space-y-6 flex flex-col items-center">
      <h2 className="text-xl font-semibold text-slate-900">{page.question}</h2>
      <div className="space-y-2 w-full">
        {page.options.map((option) => (
          <OptionButton
            key={option.value}
            option={option}
            selected={value === option.value}
            onClick={() => onSelect(option.value)}
          />
        ))}
      </div>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-8" />
      )}
    </div>
  )
}
